export default __webpack_public_path__ + "static/N0028-ff3c6275ec3adbcdb79146dbc960622b.png";